/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { KTSVG } from '../../../../../../_metronic/helpers'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { IUpdatePassword, updatePassword } from '../SettingsModel'
import { updateUserPassword } from '../../../../../master/api'
import { swlAlert } from '../../../../../component'

// const emailFormValidationSchema = Yup.object().shape({
//   newEmail: Yup.string()
//     .email('Wrong email format')
//     .min(3, 'Minimum 3 symbols')
//     .max(50, 'Maximum 50 symbols')
//     .required('Email is required'),
//   confirmPassword: Yup.string()
//     .min(3, 'Minimum 3 symbols')
//     .max(50, 'Maximum 50 symbols')
//     .required('Password is required'),
// })

const passwordFormValidationSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .required('Current password is required'),
  newPassword: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .max(50, 'Password must not exceed 50 characters')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    .matches(/[0-9]/, 'Password must contain at least one number')
    .matches(/[^A-Za-z0-9]/, 'Password must contain at least one special character')
    .required('Password is required'),
  passwordConfirmation: Yup.string()
    .required('Please confirm your password')
    .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
})

const generateStrongPassword = () => {
  const length = 12
  // Exclude lookalikes (0/O/o, 1/l/I) and hard-to-copy specials
  const uppercaseChars = 'ABCDEFGHJKLMNPQRSTUVWXYZ'
  const lowercaseChars = 'abcdefghijkmnpqrstuvwxyz'
  const numberChars = '23456789'
  const specialChars = '@'

  const allChars = uppercaseChars + lowercaseChars + numberChars + specialChars
  let password = ''

  // Ensure at least one of each type
  password += uppercaseChars[Math.floor(Math.random() * uppercaseChars.length)]
  password += lowercaseChars[Math.floor(Math.random() * lowercaseChars.length)]
  password += numberChars[Math.floor(Math.random() * numberChars.length)]
  password += specialChars[Math.floor(Math.random() * specialChars.length)]

  // Fill the rest randomly
  for (let i = password.length; i < length; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)]
  }

  // Shuffle the password
  return password.split('').sort(() => Math.random() - 0.5).join('')
}

const SignInMethod: React.FC = () => {
  // const [emailUpdateData, setEmailUpdateData] = useState<IUpdateEmail>(updateEmail)
  const [passwordUpdateData, setPasswordUpdateData] = useState<IUpdatePassword>(updatePassword)
  const [generatedPassword, setGeneratedPassword] = useState('')
  const [showGeneratedPassword, setShowGeneratedPassword] = useState(false)
  const [showCopyTooltip, setShowCopyTooltip] = useState(false)

  const handleCopyPassword = async () => {
    if (generatedPassword) {
      try {
        await navigator.clipboard.writeText(generatedPassword)
        setShowCopyTooltip(true)
        setTimeout(() => setShowCopyTooltip(false), 2000)
      } catch (err) {
        console.error('Failed to copy password:', err)
      }
    }
  }

  // const [showEmailForm, setShowEmailForm] = useState<boolean>(false)
  const [showPasswordForm, setPasswordForm] = useState<boolean>(false)

  // const [loading1, setLoading1] = useState(false)

  // const formik1 = useFormik<IUpdateEmail>({
  //   initialValues: {
  //     ...emailUpdateData,
  //   },
  //   validationSchema: emailFormValidationSchema,
  //   onSubmit: (values) => {
  //     setLoading1(true)
  //     setTimeout((values) => {
  //       setEmailUpdateData(values)
  //       setLoading1(false)
  //       setShowEmailForm(false)
  //     }, 1000)
  //   },
  // })

  const [loading2, setLoading2] = useState(false)

  const formik2 = useFormik<IUpdatePassword>({
    initialValues: {
      ...passwordUpdateData,
    },
    validationSchema: passwordFormValidationSchema,
    onSubmit: (values) => {
      setLoading2(true)
      updateUserPassword(values.currentPassword, values.newPassword, values.passwordConfirmation).then((response) => {
        swlAlert(response?.data)
        if (Number(response.data.code) === 1) {
          setPasswordUpdateData(values)

          setPasswordForm(false)
        }
        setLoading2(false)
      }, (error) => {
        console.error('Failed to update password:', error)
        setLoading2(false)
      })
    },
  })

  return (
    <div className='card shadow-sm-bottom border-0 mb-5 mb-xl-10'>
      <div
        className='card-header bg-light py-5 cursor-pointer'
      // role='button'
      //  data-bs-toggle='collapse'
      // data-bs-target='#kt_account_signin_method'
      >
        <div className='card-title d-flex align-items-center'>
          <KTSVG
            path='/media/icons/duotune/general/gen047.svg'
            className='svg-icon-2 me-2 text-primary'
          />
          <h3 className='fw-bold m-0'>Sign-in Method</h3>
        </div>
      </div>

      <div id='kt_account_signin_method' className='collapse show'>
        <div style={{ backgroundColor: '#f9f9f9' }} className='card-body p-9'>
          {/* <div className='d-flex flex-wrap align-items-center'>
            <div id='kt_signin_email' className={' ' + (showEmailForm && 'd-none')}>
              <div className='fs-6 fw-semibolder mb-1'>Email Address</div>
              <div className='fw-semibold text-gray-600'>support@keenthemes.com</div>
            </div>

            <div
              id='kt_signin_email_edit'
              className={'flex-row-fluid ' + (!showEmailForm && 'd-none')}
            >
              <form
                onSubmit={formik1.handleSubmit}
                id='kt_signin_change_email'
                className='form'
                noValidate
              >
                <div className='row mb-6'>
                  <div className='col-lg-6 mb-4 mb-lg-0'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='emailaddress' className='form-label fs-6 fw-semibolder mb-3'>
                        Enter New Email Address
                      </label>
                      <input
                        type='email'
                        className='form-control form-control-lg form-control-solid'
                        id='emailaddress'
                        placeholder='Email Address'
                        {...formik1.getFieldProps('newEmail')}
                      />
                      {formik1.touched.newEmail && formik1.errors.newEmail && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik1.errors.newEmail}</div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <div className='fv-row mb-0'>
                      <label
                        htmlFor='confirmemailpassword'
                        className='form-label fs-6 fw-semibolder mb-3'
                      >
                        Confirm Password
                      </label>
                      <input
                        type='password'
                        className='form-control form-control-lg form-control-solid'
                        id='confirmemailpassword'
                        {...formik1.getFieldProps('confirmPassword')}
                      />
                      {formik1.touched.confirmPassword && formik1.errors.confirmPassword && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik1.errors.confirmPassword}</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className='d-flex'>
                  <button
                    id='kt_signin_submit'
                    type='submit'
                    className='btn btn-primary  me-2 px-6'
                  >
                    {!loading1 && 'Update Email'}
                    {loading1 && (
                      <span className='indicator-progress' style={{ display: 'block' }}>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  <button
                    id='kt_signin_cancel'
                    type='button'
                    onClick={() => {
                      setShowEmailForm(false)
                    }}
                    className='btn btn-color-gray-400 btn-active-light-primary px-6'
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>

            <div id='kt_signin_email_button' className={'ms-auto ' + (showEmailForm && 'd-none')}>
              <button
                onClick={() => {
                  setShowEmailForm(true)
                }}
                className='btn btn-light btn-active-light-primary'
              >
                Change Email
              </button>
            </div>
          </div> 

          <div className='separator separator-dashed my-6'></div>*/}

          <div className=''>
            {/* <div
              id='kt_signin_password'
              className={'opacity-100 ' + (showPasswordForm && 'opacity-0 d-none')}
              style={{ transition: 'opacity 0.3s ease-in-out' }}
            >
              <div className='d-flex flex-column'>
                <div className='fs-5 fw-bold mb-1'>Password</div>
                <div className='fs-7 fw-semibold text-gray-500'>Securely stored</div>
                <div className='fw-bold text-gray-600 mt-2'>••••••••••••</div>
              </div>
            </div> */}

            <div
              id='kt_signin_password_edit'
              // className={'flex-row-fluid ' + (!showPasswordForm && 'd-none')}
              style={{
                transition: 'all 0.3s ease-in-out',
                transform: showPasswordForm ? 'translateY(0)' : 'translateY(10px)',
                //opacity: showPasswordForm ? '1' : '0'
              }}
            >
              <form
                onSubmit={formik2.handleSubmit}
                id='kt_signin_change_password'
                className='form'
                noValidate
              >
                <div className='row g-3 mb-1'>
                  <div className='col-12 col-md-6 col-lg-4'>
                    <div className='fv-row'>
                      <label htmlFor='currentpassword' className='form-label fs-6 fw-bold mb-2'>
                        Current Password
                        <span className='ms-1 fs-7 text-gray-500'>(required)</span>
                      </label>
                      <div className='input-group input-group-lg'>
                        <span className='input-group-text bg-light'>
                          <KTSVG
                            path='/media/icons/duotune/general/gen044.svg'
                            className='svg-icon-2'
                          />
                        </span>
                        <input
                          type='password'
                          className='form-control form-control-lg bg-light-subtle border-start-0'
                          style={{ transition: 'all 0.2s ease-in-out' }}
                          id='currentpassword'
                          {...formik2.getFieldProps('currentPassword')}
                        />
                      </div>
                      {formik2.touched.currentPassword && formik2.errors.currentPassword && (
                        <div className='fv-plugins-message-container mt-2'>
                          <div className='fv-help-block text-danger'>{formik2.errors.currentPassword}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-12 col-md-6 col-lg-4'>
                    <div className='fv-row'>
                      <label htmlFor='newpassword' className='form-label fs-6 fw-bold mb-2'>
                        New Password
                        <span className='ms-1 fs-7 text-gray-500'>(required)</span>
                      </label>
                      <div className='input-group input-group-lg'>
                        <span className='input-group-text bg-light'>
                          <KTSVG
                            path='/media/icons/duotune/general/gen044.svg'
                            className='svg-icon-2'
                          />
                        </span>
                        <input
                          type={showGeneratedPassword ? 'text' : 'password'}
                          className='form-control form-control-lg bg-light-subtle border-start-0'
                          style={{ transition: 'all 0.2s ease-in-out' }}
                          id='newpassword'
                          value={generatedPassword || formik2.values.newPassword}
                          onChange={(e) => {
                            formik2.handleChange(e)
                            setGeneratedPassword('')
                          }}
                          onBlur={formik2.handleBlur}
                          name='newPassword'
                        />
                        <button
                          type='button'
                          className='btn btn-light-primary btn-icon btn-lg'
                          onClick={() => {
                            const newPassword = generateStrongPassword()
                            setGeneratedPassword(newPassword)
                            formik2.setFieldValue('newPassword', newPassword)
                            setShowGeneratedPassword(true)
                          }}
                          title='Generate Strong Password'
                        >
                          <KTSVG
                            path='/media/icons/duotune/general/gen005.svg'
                            className='svg-icon-2'
                          />
                        </button>
                        <button
                          type='button'
                          className='btn btn-light-primary btn-icon btn-lg'
                          onClick={() => setShowGeneratedPassword(!showGeneratedPassword)}
                          title={showGeneratedPassword ? 'Hide Password' : 'Show Password'}
                        >
                          <KTSVG
                            path={showGeneratedPassword ? '/media/icons/duotune/general/gen020.svg' : '/media/icons/duotune/general/gen021.svg'}
                            className='svg-icon-2'
                          />
                        </button>
                        {generatedPassword && (
                          <button
                            type='button'
                            className={'btn btn-light-primary btn-icon btn-lg position-relative' + (showCopyTooltip ? ' active' : '')}
                            onClick={handleCopyPassword}
                            title='Copy Password'
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/gen054.svg'
                              className='svg-icon-2'
                            />
                            {showCopyTooltip && (
                              <div
                                className='position-absolute bg-success text-white px-2 py-1 rounded'
                                style={{
                                  fontSize: '0.8rem',
                                  bottom: '-30px',
                                  left: '50%',
                                  transform: 'translateX(-50%)',
                                  whiteSpace: 'nowrap',
                                  zIndex: 1
                                }}
                              >
                                Copied!
                              </div>
                            )}
                          </button>
                        )}
                      </div>
                      {generatedPassword && (
                        <div className='form-text mt-2 d-flex align-items-center'>
                          <KTSVG
                            path='/media/icons/duotune/general/gen045.svg'
                            className='svg-icon-2 text-success me-2'
                          />
                          <span className='text-success'>Strong password generated!</span>
                        </div>
                      )}
                      {formik2.touched.newPassword && formik2.errors.newPassword && (
                        <div className='fv-plugins-message-container mt-2'>
                          <div className='fv-help-block text-danger'>{formik2.errors.newPassword}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-12 col-md-6 col-lg-4'>
                    <div className='fv-row'>
                      <label htmlFor='confirmpassword' className='form-label fs-6 fw-bold mb-2'>
                        Confirm New Password
                        <span className='ms-1 fs-7 text-gray-500'>(required)</span>
                      </label>
                      <div className='input-group input-group-lg'>
                        <span className='input-group-text bg-light'>
                          <KTSVG
                            path='/media/icons/duotune/general/gen044.svg'
                            className='svg-icon-2'
                          />
                        </span>
                        <input
                          type='password'
                          className='form-control form-control-lg bg-light-subtle border-start-0'
                          style={{ transition: 'all 0.2s ease-in-out' }}
                          id='confirmpassword'
                          {...formik2.getFieldProps('passwordConfirmation')}
                        />
                      </div>
                      {formik2.touched.passwordConfirmation && formik2.errors.passwordConfirmation && (
                        <div className='fv-plugins-message-container mt-2'>
                          <div className='fv-help-block text-danger'>{formik2.errors.passwordConfirmation}</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className='form-text mb-5'>
                  <div className='text-gray-600 fw-semibold fs-6 mb-2'>Password requirements:</div>
                  <div className='d-flex flex-column ps-3'>
                    <span className='fs-7 text-gray-500 mb-1'>• Minimum 8 characters long</span>
                    <span className='fs-7 text-gray-500 mb-1'>• At least one uppercase letter</span>
                    <span className='fs-7 text-gray-500 mb-1'>• At least one number</span>
                    <span className='fs-7 text-gray-500'>• At least one special character</span>
                  </div>
                </div>

                <div className='d-flex flex-stack flex-wrap gap-3 mt-4'>
                  <div className='d-flex flex-column flex-md-row gap-3'>
                    <button
                      id='kt_password_submit'
                      type='submit'
                      className='btn btn-primary btn-lg px-8 d-inline-flex align-items-center hover-elevate-up'
                      style={{ transition: 'all 0.2s ease' }}
                    >
                      {!loading2 && (
                        <>
                          <KTSVG
                            path='/media/icons/duotune/general/gen016.svg'
                            className='svg-icon-2 me-2'
                          />
                          Update Password
                        </>
                      )}
                      {loading2 && (
                        <span className='indicator-progress d-flex align-items-center'>
                          Please wait...{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                    {/* <button
                      onClick={() => {
                        setPasswordForm(false)
                      }}
                      id='kt_password_cancel'
                      type='button'
                      className='btn btn-light btn-lg px-8 d-inline-flex align-items-center hover-elevate-up'
                      style={{ transition: 'all 0.2s ease' }}
                    >
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr011.svg'
                        className='svg-icon-2 me-2'
                      />
                      Cancel
                    </button> */}
                  </div>
                </div>
              </form>
            </div>

            {/* <div
              id='kt_signin_password_button'
              className={'ms-auto ' + (showPasswordForm && 'd-none')}
            >
              <button
                onClick={() => {
                  setPasswordForm(true)
                }}
                className='btn btn-light btn-active-light-primary d-inline-flex align-items-center hover-elevate-up'
                style={{ transition: 'all 0.2s ease' }}
              >
                <KTSVG
                  path='/media/icons/duotune/general/gen035.svg'
                  className='svg-icon-2 me-2'
                />
                Reset Password
              </button>
            </div> */}
          </div>

          {/* <div className='notice d-flex bg-light-primary rounded border-primary border border-dashed p-6'>
            <KTSVG
              path='/media/icons/duotune/general/gen048.svg'
              className='svg-icon-2tx svg-icon-primary me-4'
            />
            <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
              <div className='mb-3 mb-md-0 fw-semibold'>
                <h4 className='text-gray-800 fw-semibolder'>Secure Your Account</h4>
                <div className='fs-6 text-gray-600 pe-7'>
                  Two-factor authentication adds an extra layer of security to your account. To log
                  in, in addition you'll need to provide a 6 digit code
                </div>
              </div>
              <a
                href='#'
                className='btn btn-primary px-6 align-self-center text-nowrap'
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_two_factor_authentication'
              >
                Enable
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export { SignInMethod }
